export enum CartSource {
    BuyNow = 'BUY_NOW',
}
